import { MenuItem } from 'generated/graphql';
import { create } from 'zustand';

interface LayoutStoreType {
    menuIsFiltred: boolean;
    menu: MenuItem[];
    footer: string;
    setLayoutState: (menu: MenuItem[], footer: string) => void;
    setShouldFilterMenu: (value: boolean) => void;
}

const useLayout = create<LayoutStoreType>((set) => ({
    menuIsFiltred: false,
    menu: [],
    footer: '',
    setLayoutState: (menu, footer, shouldFilterMenu = false) => {
        const filteredMenu = shouldFilterMenu
            ? menu.filter((item) => item.slug !== '/findconsultant')
            : menu;

        set({
            menu: filteredMenu,
            footer,
            menuIsFiltred: shouldFilterMenu,
        });
    },
    setShouldFilterMenu: (value: boolean) => set({ menuIsFiltred: value }),
}));

export default useLayout;
